class DatepickerInlineInterface {


    selectors;

    constructor() {
        this.selectors = new DatepickerInlineSelectors();
    }


}